export const areas = [
  {
    slug: "lamia",
    path: "/episkevi-kiniton-lamia",
    name: "Λαμία",
    inArea: "στη Λαμία",
    ofArea: "της Λαμίας",
    title: "Επισκευή Κινητών Λαμία – Κατ' οίκον, Αυθημερόν | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop & υπολογιστών στη Λαμία κατ' οίκον. Αλλαγή οθόνης από 25€ σε 30-60 λεπτά, 6 μήνες εγγύηση, δωρεάν διάγνωση. Τηλ. 6982917870.",
    eta: "Συνήθως εντός 1-2 ωρών από την κλήση σας",
    intro: [
      "Η Repairzone Π.Κ έχει έδρα τη Λαμία και εξυπηρετεί καθημερινά όλες τις γειτονιές της πόλης: κέντρο, Γαλανέικα, Νέα Μαγνησία, Άγιο Λουκά, Ταράτσα, Καλύβια, Ροδίτσα, Ανθήλη και Λιανοκλάδι. Δεν χρειάζεται να ψάξετε κατάστημα και πάρκινγκ – ερχόμαστε εμείς στο σπίτι ή στο γραφείο σας με πλήρη εξοπλισμό.",
      "Οι πιο συχνές επισκευές που κάνουμε στη Λαμία είναι αλλαγή οθόνης σε iPhone, Samsung και Xiaomi, αντικατάσταση μπαταρίας, επισκευή θύρας φόρτισης και καθαρισμός laptop που υπερθερμαίνεται. Οι περισσότερες ολοκληρώνονται επί τόπου σε 30-60 λεπτά, ενώ για πιο σύνθετες βλάβες (μητρική, ανάκτηση δεδομένων) παραλαμβάνουμε και παραδίδουμε δωρεάν.",
      "Εξυπηρετούμε φοιτητές, επαγγελματίες και επιχειρήσεις της Λαμίας με τιμές χωρίς κρυφές χρεώσεις, γνήσια ή premium ανταλλακτικά και 6 μήνες γραπτή εγγύηση σε κάθε επισκευή.",
    ],
    nearby: ["Γαλανέικα", "Νέα Μαγνησία", "Ροδίτσα", "Ανθήλη", "Καλύβια", "Λιανοκλάδι", "Γοργοπόταμος", "Ξηριάς", "Κόμμα", "Σταυρός"],
    faqs: [
      {
        q: "Πόσο γρήγορα μπορείτε να έρθετε στη Λαμία;",
        a: "Στη Λαμία συνήθως βρισκόμαστε στον χώρο σας μέσα σε 1-2 ώρες από την κλήση. Για επείγοντα (π.χ. κινητό εργασίας) προσπαθούμε ακόμα πιο γρήγορα – καλέστε στο 6982917870.",
      },
      {
        q: "Πόσο κοστίζει η αλλαγή οθόνης κινητού στη Λαμία;",
        a: "Ξεκινά από 25€ ανάλογα με το μοντέλο. Σας λέμε την ακριβή τιμή τηλεφωνικά πριν έρθουμε, χωρίς έκπληξη στο τέλος.",
      },
      {
        q: "Έχετε κατάστημα στη Λαμία;",
        a: "Λειτουργούμε ως κινητό συνεργείο με εργαστήριο στη Λαμία. Εξυπηρετούμε αποκλειστικά κατ' οίκον και με δωρεάν παραλαβή/παράδοση, ώστε να μην χάνετε χρόνο.",
      },
    ],
  },
  {
    slug: "amfikleia",
    path: "/episkevi-kiniton-amfikleia",
    name: "Αμφίκλεια",
    inArea: "στην Αμφίκλεια",
    ofArea: "της Αμφίκλειας",
    title: "Επισκευή Κινητών Αμφίκλεια & Ελάτεια – Κατ' οίκον | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop & tablet στην Αμφίκλεια, Ελάτεια, Τιθορέα και Κάτω Τιθορέα κατ' οίκον. Αλλαγή οθόνης, μπαταρίας, καθαρισμός laptop. 6 μήνες εγγύηση. Τηλ. 6982917870.",
    eta: "Προγραμματισμένες επισκέψεις 2-3 φορές την εβδομάδα, συνήθως αυθημερόν ή επόμενη μέρα",
    intro: [
      "Μένετε στην Αμφίκλεια, την Ελάτεια, την Τιθορέα ή τα χωριά του Παρνασσού και χάλασε το κινητό ή το laptop; Δεν χρειάζεται να κατεβείτε στη Λαμία ή στη Λιβαδειά. Η Repairzone Π.Κ έρχεται στην περιοχή σας με προγραμματισμένα δρομολόγια και επισκευάζει τη συσκευή σας επί τόπου.",
      "Στην Αμφίκλεια και την ευρύτερη περιοχή του Δήμου Αμφίκλειας-Ελάτειας ζητούνται κυρίως αλλαγές οθόνης και μπαταρίας σε Samsung και Xiaomi, επισκευή tablet για παιδιά, format και καθαρισμός laptop, καθώς και αντιμετώπιση ιών σε υπολογιστές γραφείου. Για ό,τι δεν γίνεται επί τόπου, παραλαμβάνουμε τη συσκευή και την επιστρέφουμε επισκευασμένη χωρίς χρέωση μεταφοράς.",
      "Επειδή η απόσταση από τη Λαμία είναι περίπου 45 λεπτά, συγκεντρώνουμε τα ραντεβού της περιοχής ώστε να σας εξυπηρετούμε αυθημερόν ή το αργότερο την επόμενη μέρα – και πάντα με 6 μήνες εγγύηση.",
    ],
    nearby: ["Ελάτεια", "Τιθορέα", "Κάτω Τιθορέα", "Πολύδροσος", "Δρυμαία", "Ζέλι", "Μόδι", "Λιλαία"],
    faqs: [
      {
        q: "Πόσο κοστίζει η μετάβαση στην Αμφίκλεια;",
        a: "Για επισκευές που γίνονται, δεν χρεώνουμε ξεχωριστά τη μετάβαση – συμπεριλαμβάνεται στην προσφορά που σας δίνουμε τηλεφωνικά. Η διάγνωση παραμένει δωρεάν.",
      },
      {
        q: "Κάθε πότε έρχεστε στην Αμφίκλεια και την Ελάτεια;",
        a: "Έχουμε δρομολόγια 2-3 φορές την εβδομάδα και έκτακτα όταν υπάρχει επείγουσα ανάγκη. Καλέστε μας και σας λέμε την επόμενη διαθέσιμη ώρα.",
      },
      {
        q: "Επισκευάζετε και παλιότερα μοντέλα κινητών;",
        a: "Ναι. Έχουμε ανταλλακτικά για τα περισσότερα Samsung, Xiaomi, Huawei και iPhone των τελευταίων 8 ετών. Αν χρειαστεί παραγγελία, σας ενημερώνουμε για τον χρόνο.",
      },
    ],
  },
  {
    slug: "stylida",
    path: "/episkevi-kiniton-stylida",
    name: "Στυλίδα",
    inArea: "στη Στυλίδα",
    ofArea: "της Στυλίδας",
    title: "Επισκευή Κινητών Στυλίδα – Κατ' οίκον, Αυθημερόν | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop, tablet & υπολογιστών στη Στυλίδα, Αγία Μαρίνα, Ράχες και Πελασγία κατ' οίκον. Αλλαγή οθόνης από 25€, 6 μήνες εγγύηση. Τηλ. 6982917870.",
    eta: "Αυθημερόν – η Στυλίδα απέχει μόλις 15 λεπτά από τη Λαμία",
    intro: [
      "Η Στυλίδα είναι από τις περιοχές που εξυπηρετούμε πιο συχνά: απέχει μόλις 15 λεπτά από τη βάση μας στη Λαμία, οπότε στις περισσότερες περιπτώσεις είμαστε στον χώρο σας την ίδια μέρα. Καλύπτουμε Στυλίδα, Αγία Μαρίνα, Καραβόμυλο, Ράχες, Αχινό και Πελασγία.",
      "Η θαλασσινή υγρασία και η άμμος είναι οι «εχθροί» των συσκευών στη Στυλίδα: βλέπουμε πολλά κινητά με οξειδωμένη θύρα φόρτισης, ηχεία που βουλώνουν και laptop με ανεμιστήρες γεμάτους σκόνη. Κάνουμε καθαρισμό υπερήχων, αλλαγή θύρας φόρτισης, αντικατάσταση οθόνης και μπαταρίας, καθώς και πλήρες service laptop με θερμοαγώγιμη πάστα.",
      "Για επιχειρήσεις εστίασης και τουρισμού της Στυλίδας προσφέρουμε προτεραιότητα την καλοκαιρινή σεζόν, ώστε να μην μένετε χωρίς POS laptop ή κινητό παραγγελιών.",
    ],
    nearby: ["Αγία Μαρίνα", "Καραβόμυλος", "Ράχες", "Αχινός", "Πελασγία", "Ανύδρο", "Αυλάκι", "Μύλοι"],
    faqs: [
      {
        q: "Μπορείτε να σώσετε κινητό που έπεσε στη θάλασσα;",
        a: "Συχνά ναι, αν δράσουμε γρήγορα. Μην το φορτίσετε και μην το βάλετε σε ρύζι – κλείστε το και καλέστε μας. Κάνουμε καθαρισμό από αλάτι/οξείδωση και ελέγχουμε την πλακέτα.",
      },
      {
        q: "Έρχεστε στη Στυλίδα και Σαββατοκύριακο;",
        a: "Ναι, είμαστε διαθέσιμοι 7 ημέρες. Το Σαββατοκύριακο προτιμάμε να κλείνουμε ραντεβού τηλεφωνικά από την προηγούμενη.",
      },
      {
        q: "Πόσο κάνει η αλλαγή μπαταρίας κινητού στη Στυλίδα;",
        a: "Από 25€ ανάλογα με το μοντέλο, με γνήσια ή premium μπαταρία και 6 μήνες εγγύηση. Ολοκληρώνεται επί τόπου σε περίπου 30 λεπτά.",
      },
    ],
  },
  {
    slug: "atalanti",
    path: "/episkevi-kiniton-atalanti",
    name: "Αταλάντη",
    inArea: "στην Αταλάντη",
    ofArea: "της Αταλάντης",
    title: "Επισκευή Κινητών Αταλάντη & Λοκρίδα – Κατ' οίκον | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop & υπολογιστών στην Αταλάντη, Λιβανάτες, Μαλεσίνα και Μαρτίνο κατ' οίκον. Οθόνες, μπαταρίες, service laptop, ανάκτηση δεδομένων. 6 μήνες εγγύηση.",
    eta: "Αυθημερόν ή επόμενη μέρα – περίπου 40 λεπτά από τη Λαμία",
    intro: [
      "Η Repairzone Π.Κ καλύπτει ολόκληρη τη Λοκρίδα με βάση την Αταλάντη: Λιβανάτες, Αρκίτσα, Μαλεσίνα, Μαρτίνο, Λάρυμνα, Τραγάνα και Σκάλα Αταλάντης. Αντί να στείλετε τη συσκευή σας με κούριερ σε Αθήνα ή Λαμία, την επισκευάζουμε στον χώρο σας ή την παραλαμβάνουμε και την επιστρέφουμε δωρεάν.",
      "Στην Αταλάντη εξυπηρετούμε πολλές μικρές επιχειρήσεις και αγροτικές εκμεταλλεύσεις που βασίζονται σε υπολογιστή και κινητό για τιμολόγηση και επικοινωνία. Αναλαμβάνουμε επισκευή και αναβάθμιση υπολογιστών (SSD, RAM, Windows), αφαίρεση ιών, backup και ανάκτηση δεδομένων, καθώς και όλες τις επισκευές κινητών και tablet.",
      "Οι τιμές είναι ίδιες με τη Λαμία – χωρίς επιπλέον χρέωση για την απόσταση όταν γίνεται επισκευή – και κάθε εργασία συνοδεύεται από 6 μήνες εγγύηση.",
    ],
    nearby: ["Λιβανάτες", "Αρκίτσα", "Μαλεσίνα", "Μαρτίνο", "Λάρυμνα", "Τραγάνα", "Σκάλα Αταλάντης", "Κυπαρίσσι"],
    faqs: [
      {
        q: "Αναλαμβάνετε υπολογιστές επιχειρήσεων στην Αταλάντη;",
        a: "Ναι. Κάνουμε επιτόπου διάγνωση, αναβάθμιση σε SSD, καθαρισμό από ιούς και ρύθμιση backup ώστε να μη χάσετε ποτέ τιμολόγια και αρχεία.",
      },
      {
        q: "Πόσο καιρό παίρνει η επισκευή αν πάρετε τη συσκευή στο εργαστήριο;",
        a: "Συνήθως 1-3 εργάσιμες ημέρες. Σας ενημερώνουμε τηλεφωνικά για τη διάγνωση και το κόστος πριν προχωρήσουμε, και την επιστρέφουμε στον χώρο σας.",
      },
      {
        q: "Επισκευάζετε κινητά και στα παραλιακά χωριά της Λοκρίδας;",
        a: "Ναι – Αρκίτσα, Λιβανάτες, Σκάλα Αταλάντης, Θεολόγος και Λάρυμνα είναι εντός των περιοχών που εξυπηρετούμε.",
      },
    ],
  },
  {
    slug: "domokos",
    path: "/episkevi-kiniton-domokos",
    name: "Δομοκός",
    inArea: "στον Δομοκό",
    ofArea: "του Δομοκού",
    title: "Επισκευή Κινητών Δομοκός – Κατ' οίκον Service | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop & υπολογιστών στον Δομοκό, Νέο Μοναστήρι, Ομβριακή και Ξυνιάδα κατ' οίκον. Αλλαγή οθόνης, μπαταρίας, service PC. 6 μήνες εγγύηση. Τηλ. 6982917870.",
    eta: "Προγραμματισμένα δρομολόγια – περίπου 35 λεπτά από τη Λαμία",
    intro: [
      "Ο Δομοκός και τα χωριά του (Νέο Μοναστήρι, Ομβριακή, Ξυνιάδα, Εκκάρα, Θαυμακός, Μακρυρράχη) εξυπηρετούνται από τη Repairzone Π.Κ με προγραμματισμένα δρομολόγια από τη Λαμία. Έτσι δεν χρειάζεται να κατεβαίνετε στην πόλη για μια αλλαγή οθόνης ή ένα format.",
      "Στην ορεινή Φθιώτιδα οι συσκευές ταλαιπωρούνται από τις πτώσεις τάσης και το κρύο: βλέπουμε συχνά καμένα τροφοδοτικά υπολογιστών, μπαταρίες laptop που «πέφτουν» απότομα και κινητά με προβλήματα φόρτισης. Φέρνουμε μαζί μας τα πιο συνηθισμένα ανταλλακτικά για Samsung, Xiaomi, iPhone και Lenovo/HP laptop ώστε η επισκευή να γίνει με μία επίσκεψη.",
      "Αν χρειάζεται εργαστήριο, παραλαμβάνουμε τη συσκευή και την επιστρέφουμε στον Δομοκό χωρίς χρέωση μεταφοράς, πάντα με 6 μήνες εγγύηση.",
    ],
    nearby: ["Νέο Μοναστήρι", "Ομβριακή", "Ξυνιάδα", "Εκκάρα", "Θαυμακός", "Μακρυρράχη", "Αγία Τριάδα", "Βαρδαλή"],
    faqs: [
      {
        q: "Πώς κλείνω ραντεβού για τον Δομοκό;",
        a: "Καλέστε ή στείλτε WhatsApp/Viber στο 6982917870 με το μοντέλο και το πρόβλημα. Σας δίνουμε τιμή και την επόμενη διαθέσιμη μέρα επίσκεψης.",
      },
      {
        q: "Ο υπολογιστής μου δεν ανοίγει μετά από διακοπή ρεύματος – επισκευάζεται;",
        a: "Στις περισσότερες περιπτώσεις ναι. Συνήθως φταίει το τροφοδοτικό, που αντικαθίσταται επί τόπου. Ελέγχουμε και τον δίσκο για να μη χάσετε αρχεία.",
      },
      {
        q: "Επισκευάζετε tablet και κονσόλες παιχνιδιών στον Δομοκό;",
        a: "Ναι – tablet (οθόνη, μπαταρία, φόρτιση) και κονσόλες PlayStation/Xbox (καθαρισμός, θερμοαγώγιμη πάστα, χειριστήρια).",
      },
    ],
  },
  {
    slug: "molos",
    path: "/episkevi-kiniton-molos",
    name: "Μώλος",
    inArea: "στον Μώλο",
    ofArea: "του Μώλου",
    title: "Επισκευή Κινητών Μώλος & Άγιος Κωνσταντίνος | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop & tablet στον Μώλο, Άγιο Κωνσταντίνο, Αγία Τριάδα και Σκάρφεια κατ' οίκον. Αλλαγή οθόνης από 25€, 6 μήνες εγγύηση, δωρεάν διάγνωση.",
    eta: "Αυθημερόν – περίπου 25 λεπτά από τη Λαμία",
    intro: [
      "Ο Μώλος, ο Άγιος Κωνσταντίνος, η Αγία Τριάδα και η Σκάρφεια βρίσκονται πάνω στον άξονα Λαμίας–Καμένων Βούρλων, γι' αυτό τους εξυπηρετούμε σχεδόν καθημερινά. Συνήθως είμαστε στον χώρο σας την ίδια μέρα που θα καλέσετε.",
      "Στις παραθαλάσσιες περιοχές του Μαλιακού οι πιο συχνές βλάβες είναι σπασμένες οθόνες κινητών από πτώσεις στην παραλία, οξείδωση από αλμύρα και laptop που υπερθερμαίνονται το καλοκαίρι. Κάνουμε αλλαγή οθόνης και μπαταρίας επί τόπου, καθαρισμό από οξείδωση και πλήρες service laptop με αλλαγή θερμοαγώγιμης πάστας.",
      "Εξυπηρετούμε μόνιμους κατοίκους αλλά και παραθεριστές που βρίσκονται στην περιοχή για λίγες μέρες – καλέστε μας και προσαρμόζουμε το ραντεβού στο πρόγραμμά σας.",
    ],
    nearby: ["Άγιος Κωνσταντίνος", "Αγία Τριάδα", "Σκάρφεια", "Καινούργιο", "Ανάβρα", "Ρεγγίνι", "Μενδενίτσα", "Θερμοπύλες"],
    faqs: [
      {
        q: "Είμαι παραθεριστής στον Άγιο Κωνσταντίνο – μπορείτε να με εξυπηρετήσετε άμεσα;",
        a: "Ναι. Οι περισσότερες επισκευές κινητού (οθόνη, μπαταρία, φόρτιση) γίνονται επί τόπου σε 30-60 λεπτά, ώστε να μην χρειαστεί να αφήσετε τη συσκευή.",
      },
      {
        q: "Πόσο κοστίζει η αλλαγή οθόνης κινητού στον Μώλο;",
        a: "Από 25€ ανάλογα με το μοντέλο – ίδιες τιμές με τη Λαμία, χωρίς χρέωση μετάβασης όταν γίνεται η επισκευή.",
      },
      {
        q: "Δίνετε εγγύηση αν φύγω από την περιοχή;",
        a: "Ναι, η 6μηνη εγγύηση ισχύει όπου κι αν βρίσκεστε. Αν προκύψει θέμα, επικοινωνείτε μαζί μας και το τακτοποιούμε.",
      },
    ],
  },
  {
    slug: "kamena-vourla",
    path: "/episkevi-kiniton-kamena-vourla",
    name: "Καμένα Βούρλα",
    inArea: "στα Καμένα Βούρλα",
    ofArea: "των Καμένων Βούρλων",
    title: "Επισκευή Κινητών Καμένα Βούρλα – Κατ' οίκον | Repairzone Π.Κ",
    description:
      "Επισκευή κινητών, laptop, tablet & υπολογιστών στα Καμένα Βούρλα και την παραλία Μαλιακού κατ' οίκον. Αλλαγή οθόνης, μπαταρίας, service laptop. 6 μήνες εγγύηση.",
    eta: "Αυθημερόν – περίπου 30 λεπτά από τη Λαμία",
    intro: [
      "Τα Καμένα Βούρλα είναι τουριστικός προορισμός με ξενοδοχεία, εστιατόρια και χιλιάδες επισκέπτες κάθε καλοκαίρι. Η Repairzone Π.Κ εξυπηρετεί κατοίκους, επιχειρήσεις και παραθεριστές με κατ' οίκον επισκευή κινητών, tablet, laptop και υπολογιστών – συνήθως την ίδια μέρα.",
      "Για τις επιχειρήσεις της περιοχής αναλαμβάνουμε επισκευή και συντήρηση υπολογιστών ρεσεψιόν, εκτυπωτών και δικτύου Wi-Fi, αφαίρεση ιών και backup. Για ιδιώτες, οι πιο συχνές εργασίες είναι αλλαγή οθόνης και μπαταρίας σε iPhone/Samsung, καθαρισμός κινητού από άμμο και αλμύρα, και service laptop που «φυσάει» δυνατά.",
      "Καλύπτουμε επίσης τον Άγιο Κωνσταντίνο, τον Μώλο και τα χωριά της Κνημίδας, με ίδιες τιμές με τη Λαμία και 6 μήνες εγγύηση.",
    ],
    nearby: ["Άγιος Κωνσταντίνος", "Μώλος", "Καινούργιο", "Λογγός", "Ρεγγίνι", "Καρυά", "Αγνάντη", "Ανάβρα"],
    faqs: [
      {
        q: "Εξυπηρετείτε ξενοδοχεία και καταστήματα στα Καμένα Βούρλα;",
        a: "Ναι, με προτεραιότητα την τουριστική σεζόν. Υπολογιστές, εκτυπωτές, δίκτυο και κινητά – συνήθως αυθημερόν.",
      },
      {
        q: "Το κινητό μου γέμισε άμμο στην παραλία – τι να κάνω;",
        a: "Μην το φυσήξετε με πεπιεσμένο αέρα και μην το φορτίσετε. Καλέστε μας· κάνουμε επαγγελματικό καθαρισμό ηχείων, θύρας και πλακέτας.",
      },
      {
        q: "Πόσο κοστίζει το service laptop στα Καμένα Βούρλα;",
        a: "Ο πλήρης καθαρισμός με αλλαγή θερμοαγώγιμης πάστας ξεκινά από 35€. Αναβαθμίσεις SSD/RAM κατόπιν προσφοράς, με 6 μήνες εγγύηση.",
      },
    ],
  },
];

export const findArea = (slug) => areas.find((a) => a.slug === slug);
